import { render, staticRenderFns } from "./microphone-off.vue?vue&type=template&id=fa9fdf08&"
import script from "./microphone-off.vue?vue&type=script&lang=js&"
export * from "./microphone-off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa9fdf08')) {
      api.createRecord('fa9fdf08', component.options)
    } else {
      api.reload('fa9fdf08', component.options)
    }
    module.hot.accept("./microphone-off.vue?vue&type=template&id=fa9fdf08&", function () {
      api.rerender('fa9fdf08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/microphone-off.vue"
export default component.exports